"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var react_datepicker_1 = __importStar(require("react-datepicker"));
var DatePickerStyle_1 = require("./DatePickerStyle");
var styles_1 = require("./styles");
var CustomInput_1 = __importDefault(require("./CustomInput"));
var layout_1 = require("../../layout");
var input_1 = require("../../input");
var utils_1 = require("./utils");
var style_1 = require("../../../style");
var icons_1 = require("../../../icons");
var CustomSideContainer_1 = __importDefault(require("./CustomSideContainer"));
var Text_1 = __importDefault(require("../../Text"));
var BaseDatePicker = react_datepicker_1.default;
var Range = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = value || [], startDate = _b[0], endDate = _b[1];
    var _c = react_2.useState(false), showMonthYearPicker = _c[0], setshowMonthYearPicker = _c[1];
    var _d = react_2.useState(false), showYearPicker = _d[0], setShowYearPicker = _d[1];
    var _e = react_2.useState(''), yearPickerStartDate = _e[0], setYearPickerStartDate = _e[1];
    var _f = react_2.useState(''), yearPickerEndDate = _f[0], setYearPickerEndDate = _f[1];
    //used to update start and end date on click of arrow.
    var _g = react_2.useState(false), updateYearPickerDate = _g[0], setUpdateYearPickerDate = _g[1];
    var endRef = react_2.useRef();
    react_2.useEffect(function () {
        var allWithClass = [];
        if (showYearPicker) {
            allWithClass = Array.from(document.getElementsByClassName('react-datepicker__year-text'));
            setYearPickerStartDate(allWithClass[0].innerHTML);
            setYearPickerEndDate(allWithClass[allWithClass.length - 1].innerHTML);
        }
    }, [showYearPicker, updateYearPickerDate]);
    var updateDates = function (start, end) {
        onChange === null || onChange === void 0 ? void 0 : onChange([start, end]);
    };
    var createCustomContainer = function (_a) {
        var children = _a.children, customeHeaderProps = __rest(_a, ["children"]);
        return (react_1.jsx(react_datepicker_1.CalendarContainer, __assign({}, customeHeaderProps),
            react_1.jsx(layout_1.Flex, { direction: "row" },
                react_1.jsx(CustomSideContainer_1.default, { updateDates: updateDates }),
                react_1.jsx(layout_1.Flex, { direction: "column" },
                    react_1.jsx(layout_1.Flex, { direction: "row" }, children)))));
    };
    var customHeader = function (_a) {
        var decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, increaseYear = _a.increaseYear, decreaseYear = _a.decreaseYear, customHeaderCount = _a.customHeaderCount, monthDate = _a.monthDate;
        return (react_1.jsx(layout_1.Flex, { justifyContent: "space-between", alignItems: "center", css: {
                borderBottom: "1px solid " + style_1.DesignSystemThemeColor.Gray.LIGHT_3,
                margin: '0 -24px',
                padding: '0 24px',
                paddingBottom: 12,
            } },
            react_1.jsx("div", null,
                (customHeaderCount === 0 || showYearPicker || showMonthYearPicker) && (react_1.jsx(input_1.Button, { variant: "flush", size: "small", onClick: function () {
                        decreaseYear();
                        setUpdateYearPickerDate(!updateYearPickerDate);
                    } },
                    react_1.jsx(input_1.Button.Icon, { icon: icons_1.ChevronLeftDouble }))),
                customHeaderCount === 0 && !showMonthYearPicker && !showYearPicker && (react_1.jsx(input_1.Button, { variant: "flush", size: "small", onClick: decreaseMonth },
                    react_1.jsx(input_1.Button.Icon, { icon: icons_1.ChevronLeft })))),
            react_1.jsx(Text_1.default.Body, { size: "md", weight: "semibold", color: style_1.DesignSystemThemeColor.Gray.DARK_2 },
                !showYearPicker && !showMonthYearPicker && (react_1.jsx("span", { onClick: function () {
                        setshowMonthYearPicker(true);
                        setShowYearPicker(false);
                    }, css: { cursor: 'pointer' } }, utils_1.months[monthDate.getMonth()])),
                showYearPicker ? (react_1.jsx("span", null,
                    yearPickerStartDate,
                    " - ",
                    yearPickerEndDate,
                    ' ')) : (react_1.jsx("span", { onClick: function () {
                        setShowYearPicker(true);
                        setshowMonthYearPicker(false);
                    }, css: { marginLeft: 8, cursor: 'pointer' } },
                    monthDate.getFullYear(),
                    ' '))),
            react_1.jsx("div", null,
                customHeaderCount === 1 && !showMonthYearPicker && !showYearPicker && (react_1.jsx(input_1.Button, { variant: "flush", size: "small", onClick: increaseMonth },
                    react_1.jsx(input_1.Button.Icon, { icon: icons_1.ChevronRight }))),
                (customHeaderCount === 1 || showMonthYearPicker || showYearPicker) && (react_1.jsx(input_1.Button, { variant: "flush", size: "small", onClick: function () {
                        increaseYear();
                        setUpdateYearPickerDate(!updateYearPickerDate);
                    } },
                    react_1.jsx(input_1.Button.Icon, { icon: icons_1.ChevronRightDouble }))))));
    };
    var onChangeHandler = function (dates) {
        var start = dates[0], end = dates[1];
        if (showMonthYearPicker) {
            setshowMonthYearPicker(false);
            setShowYearPicker(false);
        }
        else if (showYearPicker) {
            setShowYearPicker(false);
            setshowMonthYearPicker(true);
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange([start, end]);
        }
    };
    var onClickOutsideHandler = function () {
        // onChange?.([appliedStartDate, appliedEndDate]);
        setShowYearPicker(false);
        setshowMonthYearPicker(false);
    };
    return (react_1.jsx(react_2.default.Fragment, null,
        react_1.jsx(react_1.Global, { styles: [DatePickerStyle_1.datePickerStyles, styles_1.customStyles, styles_1.rangeOutsideMonth] }),
        react_1.jsx(BaseDatePicker, { onChange: onChangeHandler, startDate: startDate, endDate: endDate, ref: endRef, selectsRange: true, monthsShown: !showYearPicker && !showMonthYearPicker ? 2 : 1, calendarStartDay: 1, renderCustomHeader: customHeader, onClickOutside: onClickOutsideHandler, showPopperArrow: false, dateFormat: "MMM dd, yyyy", shouldCloseOnSelect: showMonthYearPicker || showYearPicker ? false : true, customInput: react_1.jsx(CustomInput_1.default, { value: startDate + " - " + endDate, range: true }), calendarContainer: !showYearPicker && !showMonthYearPicker && createCustomContainer, showMonthYearPicker: showMonthYearPicker, showYearPicker: showYearPicker })));
};
exports.default = Range;
